import { Outlet } from 'react-router-dom'

const PrivateRoute = ({ isAuthenticated, ...rest }: any) => {
  return <Outlet />
}

export default PrivateRoute
